import Home from "@/views/Home";
import Profile from "@/views/Profile";
import Locations from "@/views/Locations/Locations";
import Location from "@/views/Locations/Location";
import NoPermission from "@/views/NoPermission";
import Tasks from "@/views/Tasks/Tasks";
import Keywords from "@/views/Keywords/Keywords";
import AutomaticResponse from "@/views/AutomaticResponse/AutomaticResponse";
import Reviews from "@/views/Reviews/Reviews";
import Notifications from "@/views/Notifications/Notifications";
import Notification from "@/views/Notifications/Notification";
import ReviewsPending from "@/views/Reviews/ReviewsPending";
import ReviewsReport from "@/views/Reviews/ReviewsReport";
import Task from "@/views/Tasks/Task";
import {
  CAN_APPROVE_REVIEW,
  CAN_DELETE_TAGS,
  CAN_GENERATE_REPORT,
  CAN_GROUP_TAGS,
  CAN_MANAGE_LOCATIONS,
  CAN_REPLY_REVIEW,
  CAN_STORE_TAGS,
  CAN_UPDATE_TAGS,
  CAN_VIEW_TAGS,
  CAN_STORE_AUTOMATIC_RESPONSE,
  CAN_UPDATE_AUTOMATIC_RESPONSE,
  CAN_VIEW_AUTOMATIC_RESPONSE,
} from "@/constants/permissions";
import LocationBulk from "@/views/Locations/LocationBulk";

export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: Home,
    meta: {
      auth: true,
      root: true,
      icon: "mdi-view-dashboard",
      title: "Dashboard",
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      auth: true,
      root: false,
      title: "Perfil",
    },
  },
  {
    path: "/locations",
    name: "locations",
    component: Locations,
    meta: {
      auth: true,
      permissions: [CAN_MANAGE_LOCATIONS],
      root: true,
      icon: "mdi-store",
      title: "Locais",
    },
  },
  {
    path: "/location/:id",
    name: "locations-details",
    component: Location,
    meta: {
      auth: true,
      permissions: [CAN_MANAGE_LOCATIONS],
      root: false,
      title: "Detalhes do local",
    },
  },
  {
    path: "",
    name: "reviews-group",
    meta: {
      auth: true,
      permissions: [CAN_APPROVE_REVIEW, CAN_REPLY_REVIEW, CAN_GENERATE_REPORT],
      root: true,
      icon: "mdi-star",
      title: "Avaliações",
    },
    group: "reviews",
    groupHead: true,
  },
  {
    path: "/reviews",
    name: "reviews-all",
    component: Reviews,
    group: "reviews",
    meta: {
      auth: true,
      permissions: [CAN_REPLY_REVIEW],
      root: true,
      icon: "mdi-star-check",
      title: "Todas",
    },
  },
  {
    path: "/reviews/pending",
    name: "reviews-pending",
    component: ReviewsPending,
    group: "reviews",
    meta: {
      auth: true,
      permissions: [CAN_APPROVE_REVIEW],
      root: true,
      icon: "mdi-star-check-outline",
      title: "Aprovações",
    },
  },
  {
    path: "/reviews/report",
    name: "reviews-report",
    component: ReviewsReport,
    group: "reviews",
    meta: {
      auth: true,
      permissions: [CAN_GENERATE_REPORT],
      root: true,
      icon: "mdi-file-chart",
      title: "Relatório",
    },
  },
  {
    path: "/keywords",
    name: "keywords",
    component: Keywords,
    group: "reviews",
    meta: {
      auth: true,
      permissions: [
        CAN_VIEW_TAGS,
        CAN_STORE_TAGS,
        CAN_DELETE_TAGS,
        CAN_UPDATE_TAGS,
        CAN_GROUP_TAGS,
      ],
      root: true,
      icon: "mdi-label-multiple",
      title: "Tags",
    },
  },

  {
    path: "/automatic-responses",
    name: "automatic-responses",
    component: AutomaticResponse,
    meta: {
      auth: true,
      permissions: [CAN_STORE_AUTOMATIC_RESPONSE,
        CAN_UPDATE_AUTOMATIC_RESPONSE,
        CAN_VIEW_AUTOMATIC_RESPONSE,],
      root: true,
      icon: "mdi-forum",
      title: "Respostas Automáticas",
    },
  },
  {
    path: "/tasks",
    name: "tasks",
    component: Tasks,
    meta: {
      auth: true,
      root: true,
      icon: "mdi-format-list-bulleted",
      title: "Tarefas",
    },
  },
  {
    path: "/task/:id",
    name: "tasks-detail",
    component: Task,
    meta: {
      auth: true,
      title: "Detalhes da tarefa",
    },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: Notifications,
    meta: {
      auth: true,
      title: "Notificações",
    },
  },
  {
    path: "/notification/:id",
    name: "notifications-detail",
    component: Notification,
    meta: {
      auth: true,
      title: "Notificação",
    },
  },
  {
    path: "/location-bulk",
    name: "location-bulk",
    props: true,
    component: LocationBulk,
    meta: {
      auth: true,
      title: "Atualização em massa dos locais",
    },
  },
  {
    path: "/no-permission",
    name: "no-permission",
    component: NoPermission,
    meta: {
      auth: true,
      title: "Sem permissão",
    },
  },
];
